interface IDivider {
    margin?: string;
    classes?: string;
}

const Divider = (props: IDivider) => {

    const { margin } = props;

    return (
        <div className={ `border-r border-gray-500 ${ margin ? margin : 'mx-10' } ${ props.classes ?? '' }` } style={{
            height: '1.5rem',
        }}></div>
    )
};

export default Divider;